"use strict";
import React from "react";
import classNames from "classnames";
import IconButton from "../IconButton/IconButton";
import { ButtonType, ButtonSize } from "../Button/Button";
import { ChevronLeft, ChevronRight } from "../../icons";
export const BASE_CLASS_NAME = "pagination-buttons";
const Pagination = ({
  isPreviousButtonDisabled,
  isNextButtonDisabled,
  onPreviousButtonClick,
  onNextButtonClick,
  children
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: `${BASE_CLASS_NAME}` }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      isRound: true,
      size: ButtonSize.Small,
      className: classNames(`${BASE_CLASS_NAME}__arrow`, `${BASE_CLASS_NAME}__arrow--back`),
      type: ButtonType.Secondary,
      disabled: isPreviousButtonDisabled,
      icon: /* @__PURE__ */ React.createElement(ChevronLeft, null),
      tooltip: { content: "Previous Page" },
      onClick: onPreviousButtonClick
    }
  ), /* @__PURE__ */ React.createElement("div", { className: "pagination-buttons__content" }, children), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      isRound: true,
      size: ButtonSize.Small,
      className: classNames(`${BASE_CLASS_NAME}__arrow`, `${BASE_CLASS_NAME}__arrow--forward`),
      type: ButtonType.Secondary,
      disabled: isNextButtonDisabled,
      icon: /* @__PURE__ */ React.createElement(ChevronRight, null),
      tooltip: { content: "Next Page" },
      onClick: onNextButtonClick
    }
  ));
};
export default Pagination;
